import LogoHospitales from '../assets/img/luda-logo.png'
import LogoDelonia from '../assets/img/logo_delonia.png'
import NuevaMutuaSanitaria from '../assets/img/nms-logo.png'
import HLA from '../assets/img/hla-logo.png'

interface LayoutConfig {
  logo: string
  title: string
  favicon: string
}

const url = process.env.PUBLIC_URL

const hospitalesConfig = {
  logo: LogoHospitales,
  title: 'Hospitales Parque: Excelencia en Hospitales y Salud Privada',
  favicon: `${url}/favicon.ico`
}

const deloniaConfig = {
  logo: LogoDelonia,
  title: 'Delonia',
  favicon: `${url}/delonia_favicon.ico`
}

const nuevaMutuaSanitariaConfig = {
  logo: NuevaMutuaSanitaria,
  title: 'Nueva Mutua Sanitaria',
  favicon: `${url}/nms_favicon.ico`
}

const hlaConfig = {
  logo: HLA,
  title: 'HLA Hospitals',
  favicon: `${url}/hla_favicon.ico`
}

export function getLayoutConfig (): LayoutConfig {
  switch (process.env.REACT_APP_LAYOUT) {
    case 'delonia':
      return deloniaConfig
    case 'nueva-mutua-sanitaria':
      return nuevaMutuaSanitariaConfig
    case 'hla':
      return hlaConfig
    default:
      return hospitalesConfig
  }
}
